// Applicant Portal — magic-link login for applicants to see all matters/invoices.
import axios from 'axios';
import { API } from './_client';

const KEY = 'immipro_applicant_session';
const authed = axios.create({ baseURL: API.defaults.baseURL, headers: { 'Content-Type': 'application/json' } });
authed.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const applicantPortal = {
  requestLogin: (email) => axios.post(`${API.defaults.baseURL}/applicant-portal/request-login`, { email }).then((r) => r.data),
  consume: (token) => axios.post(`${API.defaults.baseURL}/applicant-portal/consume`, { token }).then((r) => r.data),
  dashboard: () => authed.get('/applicant-portal/dashboard').then((r) => r.data),
  // Doc vault
  listDocs: () => authed.get('/applicant-portal/docs').then((r) => r.data),
  uploadDoc: (file, label, matterRef) => {
    const fd = new FormData();
    fd.append('file', file);
    if (label) fd.append('label', label);
    if (matterRef) fd.append('matter_ref', matterRef);
    return authed.post('/applicant-portal/docs', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  deleteDoc: (id) => authed.delete(`/applicant-portal/docs/${id}`).then((r) => r.data),
  downloadUrl: (id) => `${API.defaults.baseURL}/applicant-portal/docs/${id}/download`,
  setToken: (t) => localStorage.setItem(KEY, t),
  getToken: () => localStorage.getItem(KEY),
  clearToken: () => localStorage.removeItem(KEY),
};

// Staff-side applicant docs
export const applicantDocsStaff = {
  list: (applicantId) => API.get(`/applicant-docs/${applicantId}/docs`).then((r) => r.data),
  downloadUrl: (id) => `${API.defaults.baseURL}/applicant-docs/docs/${id}/download`,
};

// Applicant-portal-side tasks (extends applicantPortal for portal consumers)
export const applicantPortalTasks = {
  list: () => authed.get('/applicant-portal/tasks').then((r) => r.data),
  complete: (taskId) => authed.post(`/applicant-portal/tasks/${taskId}/complete`).then((r) => r.data),
};
